/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import TagsInput from './TagsInput';
import _includes from 'lodash/includes';

import {
  DialogActions,
  DialogTitle,
  Button,
  Dialog,
  DialogContentText,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  makeStyles,
} from '@material-ui/core';

import { Form } from 'react-final-form';
import { useState } from 'react';
import { useRef } from 'react';

const useStyles = makeStyles(() => ({
  li: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

const BulkTagDialog = (props) => {
  const classes = useStyles();
  const [tags, setTags] = useState([]);
  const originalTags = useRef([]);

  const handleClose = () => {
    props.onClose();
  };

  const handleValid = () => {
    let addedTags = tags.filter((x) => !_includes(originalTags.current, x));
    let removedTags = originalTags.current.filter((x) => !_includes(tags, x));

    if (addedTags.length === 0 && removedTags.length === 0) {
      props.onSubmit([]);
      return;
    }

    let assets = editTags(props.assets, addedTags, removedTags);

    props.onSubmit(assets);
  };

  const editTags = (assets, addedTags, removedTags) => {
    return assets.map((asset) => {
      asset.tags = [...asset.tags, ...addedTags];
      asset.tags = asset.tags.filter((x) => !_includes(removedTags, x));
      return asset;
    });
  };

  const tagsIntersection = (assets) => {
    if (assets.length === 0) {
      return [];
    }
    const intersections = assets.reduce((intersection, asset) => {
      return intersection.filter((x) => _includes(asset.tags, x));
    }, assets[0].tags);
    return intersections;
  };

  const onEnter = () => {
    const tags = tagsIntersection(props.assets);
    originalTags.current = tags;
    setTags(tags);
  };

  const onChangeTag = (tags) => {
    setTags(tags);
  };

  const { onClose, assets, ...other } = props;

  return (
    <Dialog aria-labelledby="simple-dialog-title" onEnter={onEnter} {...other}>
      <DialogTitle id="simple-dialog-title">Add tags to assets</DialogTitle>
      <DialogContent>
        <Form onSubmit={() => {}}>
          {({ handleSubmit }) => (
            <form toolbar={null} record={props.record} onSubmit={handleSubmit}>
              <DialogContentText>
                Tags will be added on the following assets :
              </DialogContentText>
              <List>
                {assets.map((asset) => (
                  <ListItem key={asset.id} className={classes.li}>
                    <ListItemText>{asset.title}</ListItemText>
                  </ListItem>
                ))}
              </List>
              <TagsInput
                input={{ value: tags, onChange: onChangeTag }}
                source={'tags'}
              />
            </form>
          )}
        </Form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleValid} color="primary">
          Add Tags
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkTagDialog;
